import axios from "axios"
import { 
  TABULATOR_SELECTED,
  EDIT_TABULATOR_MODE,
  ADD_TABULATOR_MODE,
  DELETE_TABULATOR_MODE,
  GET_TABULATORS,
  CREATE_TABULATOR,
  MOD_TABULATOR,
  DELETE_TABULATOR,
  RESET_TABULATOR_SELECTED,
  CLEAR_TABULATORS
} from "redux/reducers/tabulatorsCatalog/tabulatorsCatalogReducer.js"
import { START_REQUEST_SEARCH, STOP_REQUEST_SEARCH, SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";


export const getAllTabulators = ( token ) => {
  const url = `${process.env.REACT_APP_URL}/crm/tabulators`
  const headers = { Authorization: token }
  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.get(url, { headers }).then(resp => {
      dispatch({
        type: GET_TABULATORS,
        payload: resp.data
      })
    }).catch(error => {
      const err = error.response?.data?.message?.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const getTabulators = ( token, variantID ) => {
  const url = `${process.env.REACT_APP_URL}/crm/tabulators/by_contract_variant/${variantID}`
  const headers = { Authorization: token }
  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.get(url, { headers }).then(resp => {
      dispatch({
        type: GET_TABULATORS,
        payload: resp.data
      })
    }).catch(error => {
      const err = error.response?.data?.message?.error
      dispatch({
        type: GET_TABULATORS,
        payload: []
      })
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const tabulatorSelected = (tabulator) => {
  return {
    type: TABULATOR_SELECTED,
    payload: tabulator
  }
}

export const addTabulatorMode = () => {
  return {
    type: ADD_TABULATOR_MODE,
  }
}

export const editTabulatorMode = () => {
  return {
    type: EDIT_TABULATOR_MODE,
  }
}

export const deleteTabulatorMode = () => {
  return {
    type: DELETE_TABULATOR_MODE,
  }
}

export const resetTabulatorSelected = () => {
  return {
    type: RESET_TABULATOR_SELECTED
  }
}
export const createNewTabulator = (form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/tabulators`
  const headers = { Authorization: token }
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.post(url, form, { headers }).then(resp => {
      dispatch({
        type: CREATE_TABULATOR,
        payload: {
          ...resp.data,
          rangesNum: resp.data?.ranges?.length
        }
      })
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El tabulador se ha creado con éxito', color: 'success' }
      })
    }).catch(error => {
      const err = error.response?.data?.message?.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const editTabulator = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/tabulators/${id}`
  const headers = { Authorization: token } 
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.put(url, form, { headers }).then(resp => {
      dispatch({
        type: MOD_TABULATOR,
        payload: {
          ...resp.data,
          rangesNum: resp.data?.ranges?.length
        }
      })
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El tabulador se ha modificado con éxito', color: 'success' }
      })
    }).catch(error => {
      const err = error.response?.data?.message?.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const deleteTabulator = (id, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/tabulators/${id}`
  const headers = { Authorization: token }
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.delete(url, { headers }).then(resp => {
      dispatch({
        type: DELETE_TABULATOR,
        payload: resp.data.id
      })
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El tabulador se ha eliminado con éxito', color: 'success' }
      })
    }).catch(error => {
      const err = error.response?.data?.message?.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const clearTabulators = () => {
  return {
    type: CLEAR_TABULATORS,
  }
}